import Cookies from "js-cookie";

export const isAdminMode = () =>
  (Cookies.get("userEmail") || "").includes("@akanthas.com") &&
  (Cookies.get("viewMode") || "client") === "admin";
